export default __webpack_public_path__ + "static/media/moreThanOneScan.31522fc0.png";